import { Button, IconButton } from '@chakra-ui/react'
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons'
import { faEllipsisH } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useCallback, useState } from 'react'

import useOneTimeAcknowledgement from '@/client/hooks/useOneTimeAcknowledgement'

import { CreateOrUpdateActivityModal } from './CreateOrUpdateActivityModal'
import OneTimeAnnouncement from './OneTimeAnnouncement'
import type { VolunteerActivityComponentAttributes } from './types'

export function CreateOrUpdateButton({
  activity = null,
  asAdmin = false,
}: {
  activity?: VolunteerActivityComponentAttributes | null
  asAdmin?: boolean
}): JSX.Element {
  const { acknowledgedAt: acknowledgedAtOld } = useOneTimeAcknowledgement(
    'accepted-volunteer-hours-06-02-22'
  )
  const { acknowledgedAt, onAcknowledgement } = useOneTimeAcknowledgement(
    'accepted-volunteer-hours-12-08-22'
  )

  const [showModal, setShowModal] = useState(false)

  const isUpdateMode = activity != null

  const openModal = useCallback(() => setShowModal(true), [])

  const closeModal = useCallback(() => setShowModal(false), [])

  // If the user has acknowledged either of the announcements, don't show the modal
  if (showModal && acknowledgedAtOld == null && acknowledgedAt == null) {
    return <OneTimeAnnouncement onAcknowledgement={onAcknowledgement} onClose={closeModal} />
  }

  return (
    <>
      {asAdmin ? null : isUpdateMode ? (
        <IconButton
          variant="icon"
          onClick={openModal}
          icon={<FontAwesomeIcon icon={faEllipsisH} />}
          aria-label="Update Activity"
        />
      ) : (
        <Button
          variant="ghost"
          onClick={openModal}
          rightIcon={<FontAwesomeIcon icon={faChevronRight} />}
        >
          Submit Other
        </Button>
      )}
      <CreateOrUpdateActivityModal activity={activity} onClose={closeModal} open={showModal} />
    </>
  )
}
